import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/tasks',
    name: 'ui-tasks',
    meta: {
      title: 'Задания',
      layout: 'redesign',
      accessList: [ROLES.certificate, ROLES.member],
    },
    component: () => import('@/modules/UIDesign/Tasks/views/index.vue'),
    redirect: (to) => ({
      path: '/',
    }),
  },
  {
    path: '/tasks/:taskId',
    name: 'ui-task-details',
    component: () => import('@/modules/UIDesign/Tasks/views/task-details.vue'),
    meta: {
      title: 'Заданиe',
      layout: 'redesign',
      accessList: [ROLES.certificate, ROLES.member],
    },
  },
  {
    path: '/tasks/:taskId/journals',
    name: 'ui-task-journals',
    meta: {
      layout: 'redesign',
      accessList: [ROLES.certificate, ROLES.member],
    },
    redirect: (to) => ({
      name: 'ui-task-details',
      params: {
        taskId: to.params.taskId,
      },
    }),
  },
  {
    path: '/tasks/:taskId/journals/:journalId',
    name: 'ui-task-journal-details',
    component: () => import('@/modules/UIDesign/Tasks/views/task-passing.vue'),
    meta: {
      back: true,
      isDynamicTitle: true,
      layout: 'redesign',
      accessList: [ROLES.certificate, ROLES.member],
    },
  },
];
